import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { BusinessProfileActions } from '../_actions';
import Spinner from '../_components/Spinner';
import NoResults from '../_components/NoResults';
import ModalCreateNews from '../_components/ModalCreateNews';
import ModalConfirm from '../_components/ModalConfirm';

function News() {
  const dispatch = useDispatch();
  const { news, isLoading } = useSelector(
    (state) => state.businessProfileReducers
  );
  const [show, setShow] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [deleteID, setDeleteID] = useState(null);

  useEffect(() => {
    dispatch(BusinessProfileActions.BusinessGetNews());
  }, [dispatch]);

  function deleteNew() {
    if (deleteID) {
      dispatch(BusinessProfileActions.BusinessDeleteNewById(deleteID));
    }
    setDeleteID(null);
    setShowConfirm(false);
  }

  function renderTable() {
    if (isLoading) {
      return <Spinner />;
    }

    if (news?.results?.length) {
      return news.results.map((el) => (
        <div className="col-md-4" key={el.id}>
          <div className="news-container">
            <img src={el.image} alt={el.title} />
            <div className="container-fluid">
              <div className="title">
                <i
                  className="fa fa-trash float-right pointer"
                  aria-hidden="true"
                  onClick={() => handleShowConfirm(el.id)}
                ></i>
                {el.title}
              </div>
              <div className="subtitle">{el.subtitle}</div>
            </div>
          </div>
        </div>
      ));
    }
    return <NoResults />;
  }

  function handleClose() {
    setShow(false);
    dispatch(BusinessProfileActions.BusinessGetNews());
  }

  function handleShow() {
    setShow(true);
  }

  function handleShowConfirm(id) {
    setShowConfirm(true);
    setDeleteID(id);
  }

  function handleCloseConfirm() {
    setShowConfirm(false);
  }

  return (
    <div className="news">
      {show ? <ModalCreateNews handleClose={handleClose} show={show} /> : ''}
      {showConfirm ? (
        <ModalConfirm
          handleClose={handleCloseConfirm}
          show={showConfirm}
          handleDeleteNew={deleteNew}
        />
      ) : (
        ''
      )}

      <div className="clear">
        <button
          className="btn btn-primary float-right radio25"
          onClick={handleShow}
        >
          Subir noticia
        </button>
      </div>
      <h3 className="news-title">NOTICIAS</h3>
      <div className="row news-list clear">{renderTable()}</div>
    </div>
  );
}

export { News };
